import {debugLog} from "../Utils/LogUtils";
import moment from "moment";
import {useEffect} from "react";

export default function useUpdateEffectiveDate(state) {
    const beneficiary = state.beneficiary;
    const plan = state.plan;
    const setPlan = state.setPlan;

    //When the beneficiary birthdate changes, we check if the effective date is before the birthdate.
    //The effective date also cannot be more than 6 months in the past (from the first of the current month)
    useEffect(() => {
        if (!state.enrollment.state) { return; }
        if (!beneficiary.birthdate) return;

        //Can be in the future
        //Cannot be before the bene birthdate
        //Cannot be more than 6 months in the past
        //Can be in the past

        try {
            let effectiveDate = plan.effectiveDate;
            if (!effectiveDate) {
                //Initially we set the effectiveDate to the first of the current month
                effectiveDate = moment().date(1);
            }

            if (moment(effectiveDate).isBefore(moment(beneficiary.birthdate))) {
                //Cannot be before the birthdate
                effectiveDate = moment(beneficiary.birthdate);
            }

            if (moment(effectiveDate).isBefore(moment().subtract(6, 'months'))) {
                //Cannot be more than 6 months in the past (based on first of the month)
                effectiveDate = moment().subtract(6, 'months').date(1); //First of the month, 6 months ago.
            }

            if (moment(effectiveDate).date() !== 1) {
                // The date of the effective date must be the first of the month, except for Beneficiaries born in the current month of December.
                if (moment(effectiveDate).month() === 11) {
                    // If the effective date is in December, allow modification, but ensure it's not before the beneficiary's birthdate
                    if (moment(effectiveDate).isBefore(moment(beneficiary.birthdate))) {
                        effectiveDate = moment(beneficiary.birthdate);
                    }
                } else {
                    // Beneficiary is not born in December of the current year
                    // Set the effective date to the first of the month
                    effectiveDate = moment(effectiveDate).date(1);
            
                    // If the effective date is now before the bene is born, we need to increment the month
                    if (moment(effectiveDate).isBefore(moment(beneficiary.birthdate))) {
                        // Cannot be before the birthdate
                        effectiveDate = moment(effectiveDate).add(1, 'months');
                    }
                }
            }
            

            //Effective date must be after today
            //TODO: This was added without direct reference to where this is done on the iPad
            //if (moment(effectiveDate).isBefore(moment(moment().format("YYYY-MM-DD")))) {
            //    effectiveDate = moment(effectiveDate).add(1, 'months');
            //}

            //To prevent loops, we only update the effectiveDate if it has changed.
            const newEffectiveDate = moment(effectiveDate).toDate().toISOString().substring(0, 10);
            if (newEffectiveDate !== plan.effectiveDate) {
                setPlan(prevData => ({...prevData, effectiveDate: newEffectiveDate}));
            }
        } catch (e) {
            console.error(e);
        }
        debugLog("useUpdateEffectiveDate");
    }, [beneficiary.birthdate, plan.effectiveDate]);




    const plan2 = state.plan2;
    const setPlan2 = state.setPlan2;
    //When the beneficiary birthdate changes, we check if the effective date is before the birthdate.
    //The effective date also cannot be more than 6 months in the past (from the first of the current month)
    useEffect(() => {
        if (!state.enrollment.state) { return; }
        if (!beneficiary.birthdate) return;

        //Can be in the future
        //Cannot be before the bene birthdate
        //Cannot be more than 6 months in the past
        //Can be in the past

        try {
            let effectiveDate = plan2.effectiveDate;
            if (!effectiveDate) {
                //Initially we set the effectiveDate to the first of the current month
                effectiveDate = moment().date(1);
            }

            if (moment(effectiveDate).isBefore(moment(beneficiary.birthdate))) {
                //Cannot be before the birthdate
                effectiveDate = moment(beneficiary.birthdate);
            }

            if (moment(effectiveDate).isBefore(moment().subtract(6, 'months'))) {
                //Cannot be more than 6 months in the past (based on first of the month)
                effectiveDate = moment().subtract(6, 'months').date(1); //First of the month, 6 months ago.
            }

            if (moment(effectiveDate).date() !== 1) {
                //The date of the effective date must be the first of the month, except for Beneficiaries born in the current month of December.
                if (!(moment(beneficiary.birthdate).month() === 11 && moment(beneficiary.birthdate).year() === moment().year())) {
                    //Beneficiary is not born in December of the current year
                    //Set the effective date to the first of the month
                    effectiveDate = moment(effectiveDate).date(1);

                    //If the effective date is now before the bene is born, we need to increment the month
                    if (moment(effectiveDate).isBefore(moment(beneficiary.birthdate))) {
                        //Cannot be before the birthdate
                        effectiveDate = moment(effectiveDate).add(1, 'months');
                    }
                }
            }

            //Effective date must be after today
            //TODO: This was added without direct reference to where this is done on the iPad
            //if (moment(effectiveDate).isBefore(moment(moment().format("YYYY-MM-DD")))) {
            //    effectiveDate = moment(effectiveDate).add(1, 'months');
            //}

            //To prevent loops, we only update the effectiveDate if it has changed.
            const newEffectiveDate = moment(effectiveDate).toDate().toISOString().substring(0, 10);
            if (newEffectiveDate !== plan2.effectiveDate) {
                setPlan2(prevData => ({...prevData, effectiveDate: newEffectiveDate}));
            }
        } catch (e) {
            console.error(e);
        }
        debugLog("useUpdateEffectiveDate");
    }, [beneficiary.birthdate, plan2.effectiveDate]);
}